import { render, staticRenderFns } from "./AutoConfirmSetting.vue?vue&type=template&id=80c6cd04&"
import script from "./AutoConfirmSetting.vue?vue&type=script&lang=js&"
export * from "./AutoConfirmSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports